<template>
  <!-- bg blur -->
  <Transition name="fade">
    <div
      v-if="visible"
      class="vf-backdrop-blur-surface fixed top-0 left-0 w-screen h-screen z-20"
      @click="isMobileMenuOpen ? $emit('close-mobile') : null"
    ></div>
  </Transition>
</template>

<script setup lang="ts">
defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  isMobileMenuOpen: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["close-mobile"]);
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity var(--vf-panel-enter) var(--vf-backdrop-ease);
}

.fade-leave-active {
  transition: opacity var(--vf-panel-exit) var(--vf-backdrop-ease);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
